import { addDays } from "date-fns";

export const MAX_ROOMS = 8;
export const INITIAL_CONTAINER_HEIGHT = 368;
export const INITIAL_FIELD_HEIGHT = 62;
export const EXTRA_CONTAINER_HEIGHT = 14;
export const EXTRA_FIELD_HEIGHT = 8;
export const MAX_STAY_DURATION = 15;
export const ONE_YEAR_DAYS = 365;
export const NEXT_YEAR_DATE = addDays(new Date(), ONE_YEAR_DAYS);
export const MAX_CHECKOUT_DATE = addDays(
  new Date(),
  ONE_YEAR_DAYS + MAX_STAY_DURATION
);
